import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { UserService } from '../services/user.service';
import { PopupService } from '../services/popup.service';

const nonLoggedInRoutes: any = [
	'forgot-password',
	'sign-up',
	'log-in'
];

const permissibleRoutes: any = [
	'terms-conditions',
	'reset-password',
	'add-stuff',
	'save-map',
	'email',
    'verify-email'
];

const redirectToSignupRoutes: any = [
	'link',
	'embed'
];

@Injectable()
export class PopupGuard implements CanActivate {

	constructor(public userService: UserService, public router: Router, public popupService: PopupService) {}

  canActivate(
    activatedRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

   	this.checkRoute(activatedRoute.paramMap.get('popup'), activatedRoute.firstChild && activatedRoute.firstChild.paramMap.get('inner'), activatedRoute.firstChild && activatedRoute.firstChild.firstChild && activatedRoute.firstChild.firstChild.paramMap.get('subInner'));
    return true;
  }

  checkHavePermission(routeType?) {
  	let isLoggedIn = this.userService.getLoggedIn();
  	switch(routeType) { 
	   	case 'nonLoggedInRoutes': { // Routes which can be accessed only by nonLoggedIn users
	   		isLoggedIn ? this.routeTo('/map') : '';
	   		break;
	   	}
	   	case 'permissibleRoutes': { // Routes which can be accessed by any users
	   		break;
	   	}
	   	case 'redirectToSignupRoutes': { // Routes which can be redirected to sign-up if non-loggedIn
	   		isLoggedIn ? '' : this.popupService.updateRoute('sign-up');
	   		break;
	   	}
	   	default: { // Routes which can be accessed only by loggedIn users
	   		isLoggedIn ? '' : this.routeTo('/map');
	   		break;
	   	} 
		} 
  }

  routeTo(routeUrl?) {
  	routeUrl && this.router.navigate([routeUrl], {
      queryParamsHandling: 'merge'
    });
  }

  checkRoute(popup, inner, subInner) {
  	let route = subInner ? subInner : (inner ? inner : popup);
  	let isNonLoggedInRoute = (nonLoggedInRoutes.indexOf(route) > -1);
  	let isPermissibleRoute = (permissibleRoutes.indexOf(route) > -1);
  	let isRedirectToSignupRoute = (redirectToSignupRoutes.indexOf(route) > -1);

  	(isNonLoggedInRoute) ? this.checkHavePermission('nonLoggedInRoutes') : 
  	(isPermissibleRoute) ? this.checkHavePermission('permissibleRoutes') : 
  	(isRedirectToSignupRoute) ? this.checkHavePermission('redirectToSignupRoutes') : this.checkHavePermission();
  }
}



// WEBPACK FOOTER //
// ./src/app/guards/popup.guard.ts